import { defaultEventBus } from '../../EventBus/defaultEventBus.js';
export const usePopupManager = () => ({
    open: (popup, options) => defaultEventBus.fire('popup', { type: 'open', popup, ...options }),
    update: (popup, options) => defaultEventBus.fire('popup', { type: 'update', popup, ...options }),
    close: () => defaultEventBus.fire('popup', { type: 'close' }),
});
//# sourceMappingURL=usePopupManager.js.map